import USER_ROLES from '../../../constants/userRoles.constants';

const DialogController = ($scope, $mdDialog) => {
	$scope.answer = function (answer) {
		$mdDialog.hide(answer);
	};
};

class EvaluationsListController {
	/**
	 * @param {$http} $http
	 * @param {Object} $filter
	 * @param {Object} $stateParams
	 * @param {$mdDialog} $mdDialog
	 * @param {$state} $state
	 * @param {Object} evaluationService
	 */
	constructor($http, $filter, $stateParams, $mdDialog, $state, evaluationService, userService) {
		let self = this;
		self.me = false;
		self.productId = $stateParams.productId;
        self.subEvaluations = [];
		self.query = {
			order: '-id'
		};
		self.subQuery = {
			order: '-id'
		};

        if(userService.isInRole(USER_ROLES.ROLE_ADMIN)) {
            evaluationService.getEvaluationsByProductId(self.productId).then(res => {
                self.evaluations = res;
            }).catch(e => console.log('ERROR', e));
        } else {
            $state.go('home');
        }

		this.displayDate = (input) => {
			if (isNaN(input)) {
				return input;
			} else {
				return $filter('date')(input + "000", 'dd.MM.yyyy');
			}
		};

		this.deleteEvaluation = (evaluation) => {
			$mdDialog.show(
				$mdDialog.confirm()
					.clickOutsideToClose(true)
					.title('Are you sure that you want to delete this evaluation?')
					.ok('Delete')
					.cancel('Cancel')
			).then(
				() => {
					return evaluationService.deleteEvaluation(evaluation);
				}
			).then(
				() => {
                    evaluationService.getEvaluationsByProductId(self.productId).then(res => {
						self.evaluations = res;
					}).catch(e => console.log('ERROR', e));
				}
			).catch((err) => {
				console.log(err);
			});
		};

		this.selectEvaluation = (evaluation) => {
		  self.selectedEvaluation = evaluation;
		  self.subEvaluations = [];
            evaluationService.getSubEvaluationsById(evaluation.id).then((subs) => {
                self.subEvaluations = subs;
            })
        };

		this.joinEvaluation = (evaluation) => {
            evaluationService.getJoinId(evaluation.id).then((response) => {
                let stateMode = evaluation.isMini ? 'mini' : 'evaluation';
                $state.go(stateMode + '.basicInfo', {id: response.id});
            });
        };

		this.goToEvaluation = (evaluation) => {
			let stateMode = evaluation.isMini ? 'mini' : 'evaluation';
			$state.go(`${stateMode}.basicInfo`, { id: evaluation.id });
		};

		this.copyLatestEval = productId => {
			$mdDialog.show({
				controller: DialogController,
				template: require('../../home/evaluationTypeDialog.html'),
				parent: angular.element(document.body),
				clickOutsideToClose: true
			}).then(
				res => evaluationService.copyLatestEvaluation(productId, res)
			).then(
				data => {
					let stateMode = data.isMini ? 'mini' : 'evaluation';
					if (data) {
						$mdDialog.show(
							$mdDialog.confirm()
								.clickOutsideToClose(true)
								.title('Copy of the evaluation created successfully')
								.ok('Open the evaluation')
								.cancel('Close')
						).then(() => {
							$state.go(stateMode + '.basicInfo', { id: data.id });
						}).catch(() => {
						    evaluationService.getEvaluationsByProductId(self.productId).then(res => {
						        self.evaluations = res;
						        self.subEvaluations = [];
						    }).catch(e => console.log('ERROR', e));
						});
					}
				}).catch(e => {
				console.log(e);
			});
		};

        this.printExpireComment = (date) => {
            if(date) {
                date = new Date(date);
                const now = Date.now();
                const days = Math.floor((date.getTime() - now) / 86400);

                if(days > 0) {
                    return 'expires in ' + days + ' days';
                } else {
                    return 'expired ' + (-days) + ' days ago';
                }
            }
        };

        this.showMostImportantRole = (roles) => {
            if(roles.includes(USER_ROLES.ROLE_ADMIN)) {
                return 'Admin';
            } else if(roles.includes(USER_ROLES.ROLE_MANAGER)) {
                return 'Manager';
            }
            return 'Evaluator';
        };
	};
}

export default EvaluationsListController;



// WEBPACK FOOTER //
// ./src/app/pages/lists/evaluationsList/evaluationsListController.js